import * as types from "../actions/ActionTypes";
import { getErrorMessage } from "../utilities/ErrorMessageHelper";

export const getInitialState = () => ({
    organizations: [],
    selectedUser: undefined,
    selectedOrganization: undefined,
    selectedProduct: undefined,
    users: [],
    user: {
        newPassword: "",
        login: 0,
        id: null
    },
    isImpersonating: false,
    errorMessage: null,
    isUserLocked: false,
    virtualUsers:[]
});

const impersonateReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.GET_ORGANIZATIONS_BY_VALUE_SUCCEEDED: {
        const sortedOrgs = action.organizations.sort(sortOrgByName);
        return Object.assign({}, state, { organizations: sortedOrgs, errorMessage: null, selectedUser: undefined });
    }
    case types.SELECT_USER:
        return Object.assign({}, state, { selectedUser: action.user });
    case types.SELECT_ORGANIZATION:
        return Object.assign({}, state, { selectedOrganization: action.organization, virtualUsers: [], selectedProduct: undefined });
    case types.SELECT_PRODUCT: {
        return Object.assign({}, state, {
            selectedProduct: action.product
        });
    }
    case types.GET_USERS_BY_ORG_SUCCEEDED:
        return Object.assign({}, state, { users: action.users });
    case types.USER_LOCKED: {
        const user = state.user;
        user.id = action.userId;
        return Object.assign({}, state, { isUserLocked: action.isUserLocked, user: user });
    }

    case types.GET_USER_BY_LOGIN_FAILED: {
        const message = getErrorMessage(action.error);
        return Object.assign({}, state, { errorMessage: message });
    }
    case types.RESET_USER_PASSWORD_SUCCEEDED: {
        const user = {};
        user.login = action.login;
        user.newPassword = action.newPassword;
        return Object.assign({}, state, { user: user });
    }
    case types.USER_UNLOCKED_SUCCEEDED: {
        const user = state.user;
        user.id = action.userId;
        return Object.assign({}, state, { isUserLocked: false, user: user });
    }
    case types.IMPERSONATION_FAILED: {
        const message = getErrorMessage(action.error);
        return Object.assign({}, state, { errorMessage: message });
    }
    case types.GET_VIRTUAL_USERS_BY_ORG_SUCCEEDED:
        return Object.assign({}, state, { virtualUsers: action.virtualUsers });
    default:
        return state;
    }
};

const sortOrgByName = (a, b) => {
    if (a.Name > b.Name) {
        return 1;
    }
    if (a.Name < b.Name) {
        return -1;
    }
    return 0;
};

export default impersonateReducer;
